export default __webpack_public_path__ + "static/media/asia.8049e676.svg";